<mat-card class="policy-card" [ngClass]="'severity-' + severity()" (click)="titleClick.emit()">
  <!-- Visual Header -->
  <div class="card-visual">
    <div class="visual-label">
      <mat-icon>shield</mat-icon>
      <span>{{ 'policy.card.typeLabel' | transloco }}</span>
    </div>
    <svg class="visual-icon" width="110" height="110" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M55 8L95 28V55C95 78 78 96 55 102C32 96 15 78 15 55V28L55 8Z" stroke="currentColor" stroke-width="2" fill="none" opacity="0.7"/>
      <path d="M55 22L82 37V55C82 72 71 85 55 90C39 85 28 72 28 55V37L55 22Z" stroke="currentColor" stroke-width="1.5" fill="none" opacity="0.4"/>
      <path d="M45 55L52 62L68 46" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.6"/>
    </svg>
  </div>

  <mat-card-content class="policy-card-content">
    @if (showDelete()) {
      <button class="delete-btn" mat-icon-button (click)="onDelete($event)" tabindex="-1">
        <mat-icon>close</mat-icon>
      </button>
    }

    <div class="policy-card-title">{{ policy().id | truncate: 28 }}</div>
    <div class="policy-card-subtitle">{{ title() }}</div>

    <div class="card-metadata-row">
      <span class="metadata-item">
        <mat-icon>{{ typeIcon() }}</mat-icon>
        <span>{{ typeBadge() }}</span>
      </span>
      <span class="metadata-item">
        <mat-icon>schedule</mat-icon>
        <span>{{ policy().createdAt | relativeTime: 'N/A' }}</span>
      </span>
    </div>

    <p class="card-description">{{ description() | truncate: 120 }}</p>
  </mat-card-content>
</mat-card>
